import * as React from "react";
import "@blocknote/core/fonts/inter.css";
import { BlockNoteView } from "@blocknote/mantine";
import "@blocknote/mantine/style.css";
import {
  getDefaultReactSlashMenuItems,
  SuggestionMenuController,
  useCreateBlockNote,
} from "@blocknote/react";
import { filterSuggestionItems, insertOrUpdateBlockForSlashMenu } from "@blocknote/core/extensions";
import { Clock, Ruler } from "lucide-react";
import { blocknoteSchema, Block } from "../utils/blocknote";
import { useMediaQuery } from "@uidotdev/usehooks";
import "./TaskContentEditor.css";

interface Props {
  value: Block[];
  onChange(content: Block[]): void;
}

const insertTimer = (editor: typeof blocknoteSchema.BlockNoteEditor) => ({
  title: "Timer",
  subtext: "Set a defined time span",
  onItemClick: () => {
    insertOrUpdateBlockForSlashMenu(editor, {
      type: "timer",
    });
  },
  aliases: ["stopwatch"],
  group: "Other",
  icon: <Clock size={18} />,
});

const insertMetric = (editor: typeof blocknoteSchema.BlockNoteEditor) => ({
  title: "Metric",
  subtext: "Add a recorded metric",
  onItemClick: () => {
    insertOrUpdateBlockForSlashMenu(editor, {
      type: "metric",
    });
  },
  group: "Other",
  icon: <Ruler size={18} />,
});

export function TaskContentEditor({ value, onChange }: Props) {
  const darkMode = useMediaQuery("(prefers-color-scheme: dark)");
  const editor = useCreateBlockNote({
    schema: blocknoteSchema,
    initialContent: value.length > 0 ? value : undefined,
  });

  const handleChange = () => {
    onChange(editor.document);
  };

  return (
    <BlockNoteView
      editor={editor}
      onChange={handleChange}
      theme={darkMode ? "dark" : "light"}
      slashMenu={false}
      sideMenu={false}
      style={{ height: "100%" }}
    >
      <SuggestionMenuController
        triggerCharacter="/"
        getItems={async (query) =>
          filterSuggestionItems(
            [...getDefaultReactSlashMenuItems(editor), insertTimer(editor), insertMetric(editor)],
            query,
          )
        }
      />
    </BlockNoteView>
  );
}
